function Footer() {
  return (
    <footer className="footer">
      <h3 className="logo">Nirvana<span>Sol</span></h3>
      <p>© 2026 NirvanaSol. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;